import React from 'react'

export class NotFound extends React.Component {
    render() {
        return(
            <h1>找不到页面</h1>
        )
    }
}